import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams, useNavigate, Link } from "react-router-dom";
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import { Button } from "primereact/button";
import { ProgressSpinner } from "primereact/progressspinner";

export default function AcceptInvitePage() {
  const { token } = useParams();
  const navigate = useNavigate();

  const [status, setStatus] = useState("loading"); // loading | valid | invalid | done
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    axios
      .get(`/api/auth/invite/${token}`)
      .then((res) => {
        if (res.data.success) {
          setUserName(res.data.user.name);
          setStatus("valid");
        } else {
          setStatus("invalid");
        }
      })
      .catch(() => setStatus("invalid"));
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 6) {
      setError("Password must be at least 6 characters.");
      return;
    }
    if (password !== confirm) {
      setError("Passwords do not match.");
      return;
    }
    setSubmitting(true);
    try {
      const res = await axios.post("/api/auth/accept-invite", { token, password });
      if (res.data.success) {
        setStatus("done");
        setTimeout(() => navigate("/login"), 3000);
      } else {
        setError(res.data.msg || "Something went wrong.");
      }
    } catch {
      setError("Server error. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="form-container">
      <div className="form-box">
        <Link to="/login">
          <img alt="logo" src="/site_logo.png" height="30" className="logo" />
        </Link>

        {status === "loading" && (
          <div style={{ textAlign: "center", padding: "2rem" }}>
            <ProgressSpinner />
            <p>Validating your invitation…</p>
          </div>
        )}

        {status === "invalid" && (
          <>
            <h2>Link Expired</h2>
            <p>This invitation link is invalid or has expired. Please contact your school admin.</p>
            <Link to="/login">Go to Login</Link>
          </>
        )}

        {status === "done" && (
          <>
            <h2>Account Activated!</h2>
            <p>Your password has been set and your account is now active. Redirecting to login…</p>
            <Link to="/login">Go to Login</Link>
          </>
        )}

        {status === "valid" && (
          <>
            <h2>Welcome, {userName}!</h2>
            <p className="text-color-secondary" style={{ marginTop: 0 }}>
              Set a password to activate your account.
            </p>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>New Password</label>
                <Password
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="At least 6 characters"
                  feedback={false}
                  toggleMask
                  style={{ width: "100%" }}
                  inputStyle={{ width: "100%" }}
                />
              </div>
              <div className="form-group" style={{ marginTop: "1rem" }}>
                <label>Confirm Password</label>
                <InputText
                  type="password"
                  value={confirm}
                  onChange={(e) => setConfirm(e.target.value)}
                  placeholder="Re-enter password"
                  style={{ width: "100%" }}
                />
              </div>
              {error && <p style={{ color: "var(--red-500)", marginTop: "0.5rem" }}>{error}</p>}
              <Button
                label="Activate Account"
                className="mt-3"
                style={{ width: "100%" }}
                loading={submitting}
                type="submit"
              />
            </form>
          </>
        )}
      </div>
    </div>
  );
}
